<template>
  <div>
    <div v-if="showLoader" class="loading-class">
      <div class="snippet" data-title=".dot-stretching">
        <div class="stage">
          <div class="dot-stretching"></div>
        </div>
      </div>
    </div>
    <div class="table-column" v-else>
      <div class="row pt-12">
        <div class="col-sm-9 col-md-9 col-lg-9 col-xs-9 pl-21 pt-4">
          <span class="activity-text">Activities</span>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3 col-xs-3 show_section text-right">
          <select v-model="selectedShowOption" class="input-bg select_control mb-4 fs-12" @change="showNumberOfRecords">
            <option :value="option.value" v-for="option in listOptions" :key="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="wrapper">
        <div>
          <table class="table">
            <thead class="table-border">
              <tr>
                <th :class="[field.class, field.key]" v-for="(field, index) in activityFields" :key="index">
                  <span class="pr-3 position-relative" :class="[field.extra]" @click="sortList(field)">
                    {{ field.label }}
                    <span class="sortUpAngle" :class="{ 'disable-icon': !field.ascOrder }"><i class="fa fa-angle-up sortUp" :class="{ 'disable-icon': !field.ascOrder }" aria-hidden="true"></i></span>
                    <span class="sortDownAngle" :class="{ 'disable-icon': !field.descOrder }"><i class="fa fa-angle-down sortDown" :class="{ 'disable-icon': !field.descOrder }" aria-hidden="true"></i></span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(activity, index) in activityList" :key="index">
                <td class="pl-21 checkbox">
                  <label class="">
                    <input type="checkbox" @change="scheduleActivity(activity, $event)" v-model="activities" :value="activity.taskId" />
                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                  </label>
                </td>
                <td class="pl-21 name" :title="activity.taskTitle">
                  {{ $sanitize(activity.taskTitle) }}
                </td>
                <td class="type" :title="activity.taskType">
                  {{ $sanitize(activity.taskType) }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pb-5 pl-22 pagination-conatiner" v-if="activityList && activityList.length">
            <div class="row display-inline-flex mt-21">
              <div @click="prevPage()" class="arrow-icon" :class="{ disabledPagination: currentPage <= 1 }">
                <i class="fa fa-angle-left fs-23 pt-3"></i>
              </div>
              <div class="pagination pt-3">{{ currentPage }}</div>
              <div class="pagination2 pt-3">of {{ totalPages }}</div>
              <div @click="nextPage()" class="arrow-icon pt-3" :class="{ disabledPagination: currentPage >= totalPages }">
                <i class="fa fa-angle-right fs-23"></i>
              </div>
            </div>
            <div class="btn-wrapper">
              <button class="btn cancel-btn" @click="cancelScheduling()">
                Cancel
              </button>
              <button class="btn continue-btn" :disabled="!(activitiesToScheduleList && activitiesToScheduleList.length)" @click="sendActivities()">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import toastr from "toastr";
import _ from "lodash";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
export default {
  name: "ActivityListComponent",
  props: {
    participantData: {
      type: Object,
      required: true
    },
    isManualStudyStart: {
      type: Boolean
    },
    participantStudyTrigger: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    }
  },
  data() {
    return {
      showLoader: true,
      currentPage: 1,
      totalPages: 1,
      sortValue: "taskTitle",
      sortOrder: "ASC",
      selectedShowOption: 15,
      listOptions: [
        { value: 15, text: "Show 15 items" },
        { value: 50, text: "Show 50 items" },
        { value: 100, text: "Show 100 items" }
      ],

      activityFields: [
        {
          key: "checkbox",
          ascOrder: false,
          descOrder: false,
          label: "",
          class: "pl-21",
          currentOrder: null,
          extra: "checkbox-additional"
        },
        {
          key: "taskTitle",
          ascOrder: false,
          descOrder: false,
          label: "Name",
          class: "pl-21",
          currentOrder: null
        },
        {
          key: "taskType",
          ascOrder: false,
          descOrder: false,
          label: "Type",
          class: "pl-10"
        }
      ],
      activityList: [],
      activitiesToScheduleList: [],
      typeAlias: {
        survey: "Survey",
        epro: "ePRO",
        activity: "eDRO",
        telehealth: "Telehealth"
      },
      activities: []
    };
  },
  mounted() {
    this.getActivityList();
  },

  methods: {
    getActivityList(sortOrderName = "ASC") {
      nprogress.start();
      if (this.user.userRole == "Interviewer") {
        this.participantData.telehealth = true;
      }
      const param = {
        studyId: this.$route.params.studyId,
        participantId: this.$route.params.participantId,
        status: this.participantData.participantDetails.participant.status,
        telehealth: this.participantData.telehealth,
        participantCurrentDay: this.participantData.participantDetails.participantCurrentDay,
        sortOrder: "",
        sortBy: "",
        pageIndex: this.currentPage,
        pageSize: this.selectedShowOption
      };
      /* let backendValues = {taskTitle: "name", taskType: "type"}; */
      if (this.sortValue != "") {
        param["sortBy"] = "name";
        param["sortOrder"] = sortOrderName;
      }
      if (this.isManualStudyStart && !this.participantStudyTrigger) {
        param.preScreened = true;
      }
      this.$api.getJITActivityListDataFact(param).then(
        response => {
          this.activityList = response.body && response.body.activities;
          this.totalPages = response.body && response.body.totalPages;
          this.currentPage = response.body && response.body.currentPage;
          this.selectUnselectCheckbox();
          nprogress.done();
          this.showLoader = false;
        },
        err => {
          toastr.error(err.body.message);
          nprogress.done();
          this.showLoader = false;
        }
      );
    },
    scheduleActivity(activity, event) {
      if (event && event.target && event.target.checked) {
        this.addActivity(activity);
      } else {
        this.removeActivity(activity);
      }
    },
    addActivity(activity) {
      if (activity) {
        this.activitiesToScheduleList.push(activity);
      }
    },
    removeActivity(activity) {
      const index = this.activitiesToScheduleList.findIndex(a => a.taskId === activity.taskId);
      this.activitiesToScheduleList.splice(index, 1);
    },
    sendActivities() {
      if (!(this.activitiesToScheduleList && this.activitiesToScheduleList.length)) {
        return;
      }
      const data = { activities: this.activitiesToScheduleList };
      this.$emit("getSelectedActivities", data);
    },
    showNumberOfRecords() {
      this.currentPage = 1;
      this.getActivityList();
    },
    cancelScheduling() {
      this.$emit("cancelScheduling", { showDoubleConfirmation: true });
    },
    printTypeAlias(activity) {
      const type = activity.taskType;
      for (const prop in this.typeAlias) {
        if (type === prop) {
          return this.typeAlias[prop];
        }
      }
    },
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        this.currentPage -= 1;
        this.getActivityList();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
        this.getActivityList();
      }
    },
    sortList(field) {
      this.sortValue = field.key;
      field.ascOrder = !field.ascOrder;
      if (field.ascOrder) {
        this.sortOrder = "asc";
        field.descOrder = false;
      } else {
        field.descOrder = true;
        this.sortOrder = "desc";
      }

      if (field.label == "Name") {
        this.getActivityList(this.sortOrder.toUpperCase());
      } else {
        //Reset sort flags for other keys
        this.activityFields.map(field => {
          if (field.key != this.sortValue) {
            field.ascOrder = false;
            field.descOrder = false;
          }
        });

        //this.currentPage = 1;
        this.sortActivityList(this.sortValue, this.sortOrder);
      }
    },
    selectUnselectCheckbox() {
      this.activities.splice(0, this.activities.length);
      for (const i in this.activityList) {
        for (const _i in this.activitiesToScheduleList) {
          if (this.activitiesToScheduleList[_i].taskId === this.activityList[i].taskId) {
            this.activities.push(this.activityList[i].taskId);
          }
        }
      }
    },
    sortActivityList(sortBy, sortOrder) {
      const activities = this.activityList;
      this.activityList = _.orderBy(activities, [activity => activity[sortBy].toLowerCase()], [sortOrder]);
    }
  }
};
</script>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
<style lang="scss" scoped>
.show_section {
  margin-top: 5px;
  select {
    color: #4a4a4a;
    background-image: none;
    padding: 5px;
    padding-right: 48px;
    padding-left: 10px;
  }
}

.table {
  margin-bottom: 0;
  color: #4a4a4a;

  thead {
    border: 1px solid #e4e8eb;
    border-right: 0;
    border-left: 0;
    border-top: none;

    th {
      color: #9b9b9b !important;
      border-top: none;
      border-bottom: none;
      vertical-align: top;
      font-weight: bold;
      font-size: 12px;
      background: rgba(249, 249, 251, 0.2);
      padding-top: 6px;
      padding-bottom: 6px;
      span {
        cursor: pointer;
      }
    }
  }

  tbody tr td {
    label {
      width: 21.7px;
      height: 21.7px;
      border-radius: 2px;
      border: 1px solid #d8d8d8;
      font-size: 14px;
      margin-bottom: 0px !important;
      &:hover {
        cursor: pointer;
      }
    }
    label input[type="checkbox"] {
      display: none;
    }
    label input[type="checkbox"] + .cr > .cr-icon:after {
      font-size: 11px !important;
      font-weight: 100 !important;
    }
    label input[type="checkbox"] + .cr > .cr-icon:before {
      font-size: 11px !important;
      font-weight: 100 !important;
      -webkit-transform: scale(1.5, 1.5);
      -moz-transform: scale(1.5, 1.5);
      -ms-transform: scale(1.5, 1.5);
      -o-transform: scale(1.5, 1.5);
      transform: scale(1.5, 1.5);
      position: absolute;
      top: 4px;
      left: 4px;
    }
    label input[type="checkbox"]:checked + .cr > .cr-icon {
      opacity: 1;
      background-color: #4c8ce4;
      border-radius: 2px;
      border: 1px solid #4c8ce4;
      color: #fff;
    }

    label input[type="checkbox"] + .cr > .cr-icon {
      opacity: 0;
    }
    label {
      span {
        display: block;
        width: 21.7px;
        height: 21.7px;
        position: relative;
        i {
          display: block;
          width: 21.7px;
          height: 21.7px;
          position: relative;
        }
      }
    }
  }

  th,
  td {
    padding: 13px 10px 12px 10px;
    word-break: break-all;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    &.checkbox {
      width: 44px;
      padding-right: 0px;
      .checkbox-additional {
        visibility: hidden;
      }
    }
    &.name {
      max-width: 91px;
      color: #666669;
    }
    &.type {
      max-width: 140px;
      color: #666669;
    }
  }

  tr.active {
    border: solid 1px #e4e8eb;
    background-color: rgba(211, 222, 227, 0.2);
  }
}

.table-column {
  background-color: #fff;
  border: solid 1px #e4e8eb;
  border-radius: 4px;
  font-family: "Roboto-Regular", sans-serif;
  /*  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06); */
}

.select_control {
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
}

.gridHead {
  margin-top: -7px;
}

.wrapper {
  overflow-x: hidden;
}

@media (max-width: 1199px) {
  .has-sidemenu .container {
    padding-left: 30px !important;
    padding-right: 30px !important;
    width: auto;
    max-width: inherit;
  }
}

.show_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #4a4a4a;
  right: 25px;
  top: 5px;
  padding: 0px 0px 0px 1px;
  position: absolute;
  pointer-events: none;
}

.sortDownAngle {
  position: absolute;
  margin-left: 5px;
  margin-top: 3px;
}

.sortUpAngle {
  position: absolute;
  margin-top: -4px;
  margin-left: 5px;
}

.sortUp,
.sortDown {
  cursor: pointer;
  color: #666769;
  &.disable-icon {
    color: #a8a8a8;
  }
  i {
    font-size: 11px;
  }
}

.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
  cursor: pointer;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
}

.display-inline-flex {
  display: inline-flex !important;
}

.empty-div {
  position: relative;
  min-height: 98px;
}

.emptyGrid {
  position: absolute;
  top: 50%;
  left: 48%;
  color: #4a4a4a;
  transform: translate(-50%, -48%);
}

.activity-text {
  font-family: "RobotoRegular";
  font-size: 15px;
  font-weight: 600 !important;
  color: #2d3752;
}
.pagination-conatiner {
  padding-top: 5px;
  border-top: 1px solid #e4e8eb;
}
.stage {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  margin: 0 -5%;
  overflow: hidden;
}
.btn-wrapper {
  float: right;
  margin: 21px 24px 18px 10px;
  border: unset !important;
  width: unset !important;
  .btn {
    padding: 7px 31px;
    font-family: "RobotoRegular";
    font-size: 14px;
    color: #4a4a4a;
    outline: none;
    &:hover {
      cursor: pointer;
    }
    &:active {
      outline: none;
      cursor: pointer;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &.cancel-btn {
      margin-right: 13px;
      background-color: #fff;
      border: 1px solid #e4e8eb;
    }
    &.continue-btn {
      background-color: #4c8ce4;
      color: #fff;
    }
  }
}
</style>
